export const BASE_URL = 'https://apiv2i.listgen.com';
export const FETCH_HOMEOWNER_DETAILS = '/admin/getHomeOwnerDetails';
export const SUBMIT_HO_FORM = '/admin/submitHOValuationForm';
export const SUBMIT_MAX_HO_SERVICE = '/admin/setHoValuationSiteStepVisitedByHO';
